import React, { useEffect, useLayoutEffect, useRef } from 'react'

type TrixEditorProps = {
  id: string
  onEditorReady: any
  onChange: any
} & React.HTMLAttributes<HTMLTextAreaElement>

export const SCREENREADER_ID = 'speakeasy__composer__description'

export const TrixEditor = ({
  id,
  onEditorReady,
  onChange,
  ...props
}: TrixEditorProps) => {
  const ref = useRef<HTMLElement | undefined>()

  useLayoutEffect(() => {
    const current = ref.current
    if (current) {
      const onTrixInitialize = () => {
        // eslint-disable-next-line
        // @ts-ignore
        onEditorReady(ref.current?.editor)
      }
      current.addEventListener('trix-initialize', onTrixInitialize, false)

      return () => {
        current.removeEventListener('trix-initialize', onTrixInitialize, false)
      }
    }
  }, [onEditorReady])

  useEffect(() => {
    const current = ref.current
    if (current) {
      current.addEventListener('trix-change', onChange, false)

      return () => {
        current.removeEventListener('trix-change', onChange, false)
      }
    }
  }, [onChange])

  return (
    <div id={'trix-editor-top-level'}>
      <input id={id} type="hidden" autoFocus={true} />
      {/*eslint-disable-next-line*/}
      {/*@ts-ignore*/}
      <trix-editor
        ref={ref}
        input={id}
        toolbar={'my_toolbar'}
        aria-label={props.placeholder}
        aria-describedby={SCREENREADER_ID}
        {...props}
      />
    </div>
  )
}
